import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const validateActivities = (centerId: number) => {
  return restApiClient
    .url(constructApiUrl(API.centers.validateActivities.url, { id: centerId }))
    .post()
}
